import { createMiddleware, createStart } from "@tanstack/react-start";
import { htmlCacheControl } from "@/lib/html-cache";

/**
 * Canonical host: www.ajility.com.au permanently redirects (301) to the apex,
 * preserving the path and query string. Plain http is already upgraded by the
 * platform; this covers the www host only. Preview hosts are unaffected.
 */
const canonicalHost = createMiddleware({ type: "request" }).server(({ request, next }) => {
  const url = new URL(request.url);
  if (url.hostname === "www.ajility.com.au") {
    url.hostname = "ajility.com.au";
    return new Response(null, {
      status: 301,
      headers: { Location: url.toString() },
    });
  }
  return next();
});

const publicHtmlCache = createMiddleware({ type: "request" }).server(
  async ({ request, handlerType, next }) => {
    const result = await next();
    const cacheControl = htmlCacheControl(request, result.response, handlerType);
    if (!cacheControl) return result;
    const headers = new Headers(result.response.headers);
    headers.set("Cache-Control", cacheControl);
    // Compression is negotiated by hosting, never applied to response bytes here.
    return {
      ...result,
      response: new Response(result.response.body, {
        status: result.response.status,
        statusText: result.response.statusText,
        headers,
      }),
    };
  },
);

export const startInstance = createStart(() => ({
  requestMiddleware: [canonicalHost, publicHtmlCache],
}));
